import React from "react";
import { TableCell } from "@/components/ui/table";
import StatusChangeDropdown from "./StatusChangeDropdown";
import { SupabaseNotification } from "@/types/notifications";

interface NotificationStatusCellProps {
  notification: SupabaseNotification;
}

const NotificationStatusCell = ({ notification }: NotificationStatusCellProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <TableCell>
      <div className="flex items-center gap-2">
        <div className="relative z-10">
          <StatusChangeDropdown 
            notification={notification} 
            onClick={handleClick}
          />
        </div>
      </div>
    </TableCell>
  );
};

export default NotificationStatusCell;
